import PersonalInfo from './personal-info';
import EducationInfo from './education-info';
import WorkInfo from './work-info';

export default {
	PersonalInfo,
	EducationInfo,
	WorkInfo
};
